
const state = {
  // 保存当前所选网元
  currentNode: {},
  // 保存当前所选Mo
  currentMo: {},
  // 保存当前所选Command
  currentCommand: {},
  // 批量修改模式模式
  massModifyMode: false,
  // 批量修改模式保存所选记录
  massCheckedRecords: [],
  // 判断此次执行操作是否为批量修改操作[在接收MML响应时需要做此判断]
  // 不然可能已经通过点击tab等方式修改massModifyMode值,仅靠massModifyMode判断不准确
  isMassModExecing: false,
  // 记录此次执行操作是否为命令行模式[在接收MML响应时需要做此判断]
  cmdMode: false,
  // 保存当前按钮禁用状态，在MML执行过程中，按钮处于禁用状态
  mmlOperButtonDisabled: false,
  mmlCmdButtonDisabled: false,
  currentNe: {}
};

const getters = {
  currentNode: mmlState => mmlState.currentNode,
  currentMo: mmlState => mmlState.currentMo,
  currentCommand: mmlState => mmlState.currentCommand,
  massModifyMode: mmlState => mmlState.massModifyMode,
  massCheckedRecords: mmlState => mmlState.massCheckedRecords,
  isMassModExecing: mmlState => mmlState.isMassModExecing,
  cmdMode: mmlState => mmlState.cmdMode,
  mmlOperButtonDisabled: mmlState => mmlState.mmlOperButtonDisabled,
  mmlCmdButtonDisabled: mmlState => mmlState.mmlCmdButtonDisabled,
  currentNe: mmlState => mmlState.currentNe
};

const mutations = {
  changeNode(mmlState, newNode) {
    mmlState.currentNode = newNode;
  },
  changeMo(mmlState, newMo) {
    mmlState.currentMo = newMo;
  },
  changeCommand(mmlState, newCommand) {
    mmlState.currentCommand = newCommand;
  },
  changeMassModMode(mmlState, massModifyMode) {
    mmlState.massModifyMode = massModifyMode;
  },
  changeMassChkedRecords(mmlState, massCheckedRecords) {
    mmlState.massCheckedRecords = massCheckedRecords;
  },
  changeMassModExecingState(mmlState, isMassModExecing) {
    mmlState.isMassModExecing = isMassModExecing;
  },
  changeCmdMode(mmlState, cmdMode) {
    mmlState.cmdMode = cmdMode;
  },
  changeMmlOperButtonDisabled(mmlState, mmlOperButtonDisabled) {
    mmlState.mmlOperButtonDisabled = mmlOperButtonDisabled;
  },
  changeMmlCmdButtonDisabled(mmlState, mmlCmdButtonDisabled) {
    mmlState.mmlCmdButtonDisabled = mmlCmdButtonDisabled;
  },
  changeCurrentNe(mmlState, newCurrentNe){
  mmlState.currentNe = newCurrentNe;
  }
};

const actions = {
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
